import { a174, a718, a732 } from "Components/Api/RootApiPath";

export const fetchVendorTouncheList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a732, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};
